export default __webpack_public_path__ + "static/media/truck-moving.c23c7514.svg";